import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import transition from './profile-page-layout-transition.scss';
import styles from './profile-page-layout.scss';

const ANIMATION_TIMEOUT = 400;

const ProfilePageLayout = ({ profile, children }) =>
  <div>
    <CSSTransitionGroup
      className={styles.profileContainer}
      component="div"
      transitionName={transition}
      transitionEnterTimeout={ANIMATION_TIMEOUT}
      transitionLeaveTimeout={ANIMATION_TIMEOUT}
    >
      {profile}
    </CSSTransitionGroup>
    {children}
  </div>;

ProfilePageLayout.propTypes = {
  profile: PropTypes.node,
  children: PropTypes.node,
};

export default ProfilePageLayout;



// WEBPACK FOOTER //
// ./app/components/profile-page-layout/profile-page-layout.js